import { ServiceModalName } from '@enums';
import { useAppSelector } from '../storeHooks';

export const useServiceModal = (modalName: ServiceModalName) =>
  useAppSelector((state) => state.serviceModal[modalName]);

export const useAllServiceModal = () => useAppSelector((state) => state.serviceModal);

export const useHasServiceModal = () => useAppSelector((state) => !!Object.keys(state.serviceModal).length);
